<template>
  <div class="plans">
    <h2 class="no-margin mb-10">{{ $t('trace_tokens') }}</h2>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">{{ $t('dashboard') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('trace_tokens') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="line"></div>
    <list  v-if="self !== null"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import List from '@/components/traceTokens/List'
export default {
  computed: {
    ...mapGetters([
      'self'
    ])
  },
  components: {
    List
  }
}
</script>
